
import { UI_BODY_SEMIBOLD_SM, clampText, colors } from "oolib"
import styled,{css} from "styled-components"

const { yellowHighlight, greyColor10, white } = colors;

export const TagDisplayContainerStyled = styled.div`
  background: ${white};
  position: relative;
  border: 1px solid ${greyColor10};
  min-width: 25rem;
  max-width: 45rem;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  z-index: 1000;
`

export const TagsContainerStyled = styled.div`
  max-height: 20rem;
  overflow-y: auto;
  scrollbar-width: thin; /* Firefox */
`

export const TagsContainerInnerStyled = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`

export const TagListStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.3rem;
`


export const StyledTextFragmentPreview = styled(UI_BODY_SEMIBOLD_SM)`
  background-color: ${yellowHighlight}25;
  ${clampText(2)}
  width: fit-content;
`

export const StyledActionMenuWrapper = styled.div`
position: absolute;
right: 0;
top: 0;
`